












import { Component, Vue, Watch } from 'vue-property-decorator';

import FlatButton from '@/components/common/FlatButton.vue';

import MainStorage from '@/storage/main';

@Component({
  components: { FlatButton },
})
export default class CookieConsent extends Vue {
  consent: boolean | null = null;

  get shown() {
    return this.consent !== null && !this.consent;
  }

  @Watch('consent')
  consentChanged(consent: boolean) {
    MainStorage.saveCookieConsent(consent);
  }

  mounted() {
    this.consent = MainStorage.getCookieConsent() || false;
  }

  handleAccept() {
    this.consent = true;
  }
}
